import React, { useState, useEffect } from "react";
import "./viewRating.scss";
import Header from "../../components/header/Header";
import PageHeading from "../../components/pageHeading/PageHeading";
import Footer from "../../components/footer/Footer";
import { BackIcon, EditIcon } from "../../components/Icons";
import OverAllRating from "../../components/overAllRating/OverAllRating";
import Comments from "../../components/comments/Comments";
import {
  provider_getProfile,
  fetchProviderRating,
} from "../../services/auth.service";
import { fetchImage, getFullName } from "../../utils/common";
import StarRating from "../../components/rating/StarRating";
import { useNavigate } from "react-router-dom";

const Viewrating = () => {
  const [providerData, setProviderData] = useState();
  const [rating, setRating] = useState();
  const navigate = useNavigate();
  const providerProfile = async () => {
    const providerProfile = await provider_getProfile();

    setProviderData(providerProfile.data);
  };

  const providerRating = async () => {
    const providerProfileRating = await fetchProviderRating({ pageNumber: 1 });

    setRating(providerProfileRating.data.ratings);
  };
  useEffect(() => {
    providerProfile();
    providerRating();
  }, []);

  return (
    <>
      <Header />
      <PageHeading title="Rating" />
      <div className="main-container">
        <div
          className="container-wrap"
          onClick={() => navigate("/provider/accountsetting")}
        >
          <div className="view-rating-container">
            <div className="back-wrapper">
              <div className="back-icon">
                <BackIcon />
              </div>
              <div className="back-title">Back</div>
            </div>
            <div className="view-rating-wrap box-wrapper">
              <div className="user-account-detail-top">
                <div className="user-img-wrap">
                  <div className="user-pic">
                    <img
                      src={fetchImage(providerData?.provider?.profilePic)}
                      alt="User"
                    />
                  </div>
                  <div className="edit-pic">
                    <EditIcon />
                  </div>
                </div>
                <div className="user-name-wrap">
                  <div className="username">
                    {getFullName(
                      providerData?.provider?.firstName,
                      providerData?.provider?.lastName
                    )}
                  </div>
                  <div className="user-rating-wrap">
                    <div className="rating">
                      {providerData?.provider?.ratingProvider !== null &&
                        providerData?.provider?.ratingProvider !==
                          undefined && (
                          <StarRating
                            rating={providerData?.provider?.ratingProvider}
                          />
                        )}
                    </div>
                    <div className="view-rating">
                      ({providerData?.provider?.ratingProvider}) -{" "}
                      <span>
                        {providerData?.provider?.numberOfRatings} Reviews
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="view-overall-rating-wrap">
                {" "}
                <OverAllRating data={providerData?.provider} />
              </div>

              <div className="all-review-wrapper">
                <div className="all-review-title">All Reviews</div>
                <Comments rating={rating} />
              </div>
            </div>
          </div>{" "}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Viewrating;
